module.exports = require("stream/web");